import { environment } from "./../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  APIConfig,
  EncomendasHistoricoRequest,
  EncomendasHistoricoResponse,
} from "src/app/api";
import { Observable } from "rxjs";
import { makeHttpParams } from "./utils";
import { LocalStorageService } from "../localstorage.service";

@Injectable({
  providedIn: "root",
})
export class PackageHistoryApiService {
  constructor(
    private http: HttpClient,
    private config: APIConfig,
    private localStorageService: LocalStorageService
  ) {}

  // public getPackageHistory(
  //   search: Partial<EncomendasHistoricoRequest>
  // ): Observable<EncomendasHistoricoResponse> {
  //   return this.http.get<EncomendasHistoricoResponse>(
  //     `${this.config.pedidoApiUrl}/v1/encomendas/historico`,
  //     {
  //       params: makeHttpParams(search),
  //     }
  //   );
  // }

  public getPackageHistory(
    search: Partial<EncomendasHistoricoRequest>
  ): Observable<EncomendasHistoricoResponse> {
    return this.http.get<EncomendasHistoricoResponse>(
      `${environment.angularJSconstants.URLAPIPEDIDO_REPLICA}/v1/encomendas/historico`,
      this.makeHeaders(search)
    );
  }

  private makeHeaders(search) {
    const headers = new HttpHeaders({
      Authorization: this.localStorageService.get("token"),
    });

    return {
      headers,
      params: makeHttpParams(search),
    };
  }
}
